module.exports = __webpack_public_path__ + "img/alto_bilaterale_sx.c02cf1c4.png";